export const ConfirmationIcon = () => {
    return (
        <svg width="130" height="130" viewBox="0 0 130 130" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="65" cy="65" r="64" stroke="#52B099" strokeWidth="2"/>
            <path d="M85.6668 49.5L57.2502 77.9167L44.3335 65" stroke="#52B099" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}